// Appearance API pentru Stripe Elements, din tokenii ContaLearn (light/dark).
const BORDER_LIGHT = '#d3d9de';
const BORDER_DARK = 'rgba(97, 118, 142, 0.55)';

export function stripeAppearance(dark) {
  const border = dark ? BORDER_DARK : BORDER_LIGHT;
  return {
    theme: dark ? 'night' : 'stripe',
    variables: {
      colorPrimary: '#13b8ab',
      colorDanger: '#c0392b',
      colorBackground: dark ? '#121a22' : '#ffffff',
      colorText: dark ? '#e7edf5' : '#212529',
      colorTextSecondary: dark ? '#a9b4c2' : '#7b8794',
      colorTextPlaceholder: dark ? '#6b7a8c' : '#9aa5b1',
      borderRadius: '8px',
      fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
      fontSizeBase: '16px',
    },
    rules: {
      '.Input': { border: `1px solid ${border}`, boxShadow: 'none', padding: '10px 12px' },
      '.Input:focus': { borderColor: '#13b8ab', boxShadow: '0 0 0 3px rgba(19, 184, 171, 0.18)' },
      '.Label': { fontWeight: '600', fontSize: '14px' },
      '.Tab': { border: `1px solid ${border}`, boxShadow: 'none' },
      '.Tab--selected': { borderColor: '#13b8ab', boxShadow: '0 0 0 1px #13b8ab' },
      '.Block': { border: `1px solid ${border}`, boxShadow: 'none' },
    },
  };
}
